import { createAction } from '@ngrx/store';

export enum QuoteSummaryActionsTypes {
  Init = '[Quote Summary Page] Initialised',
}

export const QuoteSummaryActions = {
  init: createAction(QuoteSummaryActionsTypes.Init),
};
